import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import liveSessionsSlice from "./slices/liveSessions";

export default function createStore() {
	const store = configureStore({
		reducer: {
			[liveSessionsSlice.reducerPath]: liveSessionsSlice.reducer,
		},
		middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(liveSessionsSlice.middleware),
	});
	setupListeners(store.dispatch);
	return store;
}

export type Store = ReturnType<typeof createStore>;
export type RootState = ReturnType<Store["getState"]>;
